<template>
    <div class="result-area longer">
      <p>Det finns förutsättningar för att orsaken till dina besvär kan vara kopplade till blodkärlens funktion. Blodflödet till penis måste öka 25 gånger för att kunna få tillräcklig erektion, vilket ställer stora krav på blodkärlen. Vanliga orsaker till att kärlsystemet kan vara påverkat är rökning, diabetes, övervikt och brist på motion. Har du inte redan kontakt med din vårdcentral avseende dessa riskfaktorer, bör du boka tid för en hälsoundersökning.</p>
      
      <p v-if="hasAdditionalInfo_alt1">Enligt dina svar kan besvären även delvis bero på:
      
        <VueFaqAccordion 
          :items="getItems()"
          borderColor="transparent"
          fontColor="#2c3e50"
          activeColor="#2c3e50"
        />
        
      </p>

      <p>Vid <span v-if="hasAdditionalInfo_alt1">ovanstående orsaker</span><span v-else>blodkärlsrelaterad orsak</span> till potensbesvär kan läkemedlet Sildenafil ha god effekt.</p>
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
import { INDICATOR } from '../../../config/indicators'

export default { 
  inject: ["formState"],
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      additionalInfoONerv: "Nervfunktionen är mycket viktig för att kunna få och bibehålla erektion. Några nervrelaterade orsaker kan vara exempelvis skada på ryggmärgen, som “biverkan” efter kirurgi i området kring penis/prostata eller mer direkta nerverelaterade sjukdomar som bryter ner nerverna (så kallade neurodegenerativa sjukdomar). Sannolikt har du som har någon av dessa sjukdomar redan kontakt med sjukvården, men om du inte skulle ha det rekommenderar vi att du tar kontakt med din vårdcentral för en bredare diskussion kring dina symtom.",

      additionalInfoOpsyk: "Nedstämdhet och stress kan både minska lust och förmågan till att få en användbar erektion. Relationen till sin tilltänkta partner kan också påverka. Psykologiska orsaker är vanligt hos yngre, där stress och osäkerhet inför att ha sex kan bidra till besvären, men förekommer i alla åldrar. Vi rekommenderar dig att ta kontakt med psykolog eller sexolog för diskussion om din situation.",

      additionalInfoOHorm: "Hormonet testosteron är viktigt för att kunna få och bibehålla erektion. Då misstanken uppkommit rekommenderas du att ta kontakt med din vårdcentral för en bredare diskussion kring dina symtom och om eventuell utredning bör göras."
    }
  },
  methods: {
    getItems() {

      let extraItems = [];

      if (this.hasAdditionalInfo_alt1) {
        let item_1 = {
          title: this.additionalInfoTrigger_alt1,
          value: this.additionalInfoTxt_alt1
        }

        extraItems.push(item_1)
      }

      if (this.hasAdditionalInfo_alt2) {
        let item_2 = {
          title: this.additionalInfoTrigger_alt2,
          value: this.additionalInfoTxt_alt2
        }

        extraItems.push(item_2)
      }

      if (this.hasAdditionalInfo_alt3) {
        let item_3 = {
          title: this.additionalInfoTrigger_alt3,
          value: this.additionalInfoTxt_alt3
        }

        extraItems.push(item_3)
      }


      return extraItems
      
    }
  },
  computed: {
    hasAdditionalInfo_alt1() {
      return this.formState.additionalInfo_alt1.length ? true : false
    },
    hasAdditionalInfo_alt2() {
      return this.formState.additionalInfo_alt2.length ? true : false
    },
    hasAdditionalInfo_alt3() {
      return this.formState.additionalInfo_alt3.length ? true : false
    },
    additionalInfoTrigger_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_NERV): {
          return "Nervrelaterad orsak"
        }
        case (INDICATOR.O_PSYK): {
          return "Psykologisk orsak"
        }
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTrigger_alt2() {
      switch (this.formState.additionalInfo_alt2) {
        case (INDICATOR.O_NERV): {
          return "Nervrelaterad orsak"
        }
        case (INDICATOR.O_PSYK): {
          return "Psykologisk orsak"
        }
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTrigger_alt3() {
      switch (this.formState.additionalInfo_alt3) {
        case (INDICATOR.O_NERV): {
          return "Nervrelaterad orsak"
        }
        case (INDICATOR.O_PSYK): {
          return "Psykologisk orsak"
        }
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_NERV): {
          return this.additionalInfoONerv
        }
        case (INDICATOR.O_PSYK): {
          return this.additionalInfoOpsyk
        }
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt2() {
      switch (this.formState.additionalInfo_alt2) {
        case (INDICATOR.O_PSYK): {
          return this.additionalInfoOpsyk
        }
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt3() {
      switch (this.formState.additionalInfo_alt3) {
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
  }
}
</script>